export default __webpack_public_path__ + "static/datelabel-dropdown-do-2-light-0f56db1e7af7bcd436dcafb3f6aa45cc.png";